/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowLeft = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M18 9v2H6l4 4-1 2-7-7 7-7 1 2-4 4h12z" />
	</SVG>
);

export default arrowLeft;
